// eslint-disable-next-line no-unused-vars
import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
/** @jsx jsx */
import { jsx } from "theme-ui"

import ServiceCard from "./ServiceCard"
import _content from "../../content/homepage/cardsSection.json"

const ServiceCards = ({ langKey }) => {
  const data = useStaticQuery(graphql`
    query ServiceCardsQuery {
      conseilStrategie: file(
        relativePath: { eq: "illustration-conseil-strategie.png" }
      ) {
        childImageSharp {
          fixed(height: 150, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      campagneRetail: file(
        relativePath: { eq: "illustration-campagnes-retail.png" }
      ) {
        childImageSharp {
          fixed(height: 150, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      brandContent: file(
        relativePath: { eq: "illustration-brand-content.png" }
      ) {
        childImageSharp {
          fixed(height: 150, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      supportOps: file(relativePath: { eq: "illustration-support-ope.png" }) {
        childImageSharp {
          fixed(height: 150, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      formation: file(relativePath: { eq: "illustration-formations.png" }) {
        childImageSharp {
          fixed(height: 150, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)
  const {
    card1Title,
    card2Title,
    card3Title,
    card4Title,
    card5Title,
  } = _content[langKey]
  return (
    <div
      sx={{
        display: `flex`,
        justifyContent: `space-between`,
        width: `100%`,
        alignItems: `center`,
        flexDirection: [`column`, `column`, `row`, `row`],
      }}
    >
      <Link sx={{ textDecoration: `none` }} to={`/amazon-agency/`}>
        <ServiceCard
          fixed={data.conseilStrategie.childImageSharp.fixed}
          title={card1Title}
        />
      </Link>
      <Link sx={{ textDecoration: `none` }} to={`/amazon-agency/`}>
        <ServiceCard
          fixed={data.brandContent.childImageSharp.fixed}
          title={card2Title}
        />
      </Link>
      <Link sx={{ textDecoration: `none` }} to={`/amazon-agency/`}>
        <ServiceCard
          fixed={data.campagneRetail.childImageSharp.fixed}
          title={card3Title}
        />
      </Link>
      <Link sx={{ textDecoration: `none` }} to={`/amazon-agency/`}>
        <ServiceCard
          fixed={data.supportOps.childImageSharp.fixed}
          title={card4Title}
        />
      </Link>
      <Link sx={{ textDecoration: `none` }} to={`/amazon-agency/`}>
        <ServiceCard
          fixed={data.formation.childImageSharp.fixed}
          title={card5Title}
        />
      </Link>
    </div>
  )
}

export default ServiceCards
